import * as React from 'react';
import {
	chakra,
	ImageProps,
	forwardRef,
} from '@chakra-ui/react';
import logo from '../../Assets/svg/chevron-circle-down.svg';

export const ChevronCircleDown = forwardRef<ImageProps, 'img'>((props, ref) => {
	return <chakra.img src={logo} ref={ref} {...props} />;
});
